import { useEffect, useRef } from "react";

export const usePrevious = value => {
  //https://usehooks.com/usePrevious/
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
